
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[main_domain]",
      function () {
        return require("private-next-pages/[main_domain]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[main_domain]"])
      });
    }
  